<template>
  <div>
    <van-sticky :offset-top="0">
      <demo-block :title="('')">
        <van-nav-bar :title="('用户个人信息')" :left-text="('返回')" left-arrow @click-left="this.$router.go(-1)">
          <template #right>
            <van-icon name="home" size="18" />
          </template>
        </van-nav-bar>
      </demo-block>
    </van-sticky>
    <div v-if="userinfo.isshowcardimg===1" style="margin: 10px;overflow: hidden;">
      <div class="m-img" :style="'background-image:url(' + userinfo.bgpic + ')'">
        <div v-if="userinfo.nameisshow===1" class="m-name" :style="'left:'+ userinfo.nameleft +'px;margin-top:'+ userinfo.nametop +'px;'">
          {{ userinfo.name }}
        </div>
        <div v-if="userinfo.dpnameisshow===1" class="m-dpname" :style="'left:'+ userinfo.dpnameleft +'px;margin-top:'+ userinfo.dpnametop +'px;'">
          {{ userinfo.dpname }}
        </div>
        <div v-if="userinfo.outidisshow===1" class="m-outid" :style="'left:'+ userinfo.outidleft +'px;margin-top:'+ userinfo.outidtop +'px;'">
          {{ userinfo.outid }}
        </div>
        <div>
          <span v-if=" 1 === 1">
            <img class="pic" :src="userinfo.facepic" :style="'width:'+ userinfo.headpicwidth  +'px;margin-left:'+ userinfo.headpicleft +'px;margin-top:'+ userinfo.headpictop +'px;'">
          </span>
        </div>
      </div>
    </div>

    <van-form style="margin-top: 9px;margin-bottom:10px;">
      <van-cell-group inset title="功能设置">
        <van-cell v-for="item in lsFunctionList" :key="item.functionid" center :title="item.functionmemo">
          <template #right-icon>
            <van-switch v-model="item.isenable" size="20" @change="SaveOptionList('wx_function', item)" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-form>

    <van-form v-if="lsBindList.length>0 && userinfo.showpaylist==1" style="margin-top: 5px;margin-bottom:10px;">
      <van-cell-group inset title="支付设置">
        <van-cell v-for="item in lsBindList" :key="item.bindtype" center :title="item.bindpayname">
          <template #right-icon>
            <van-switch v-model="item.isenable" size="20" @change="SaveBankBind('bankbindpay', item)" />
          </template>
          <van-field
            v-if="item.isenable"
            v-model="item.oddfare"
            placeholder="请输入授信金额"
          />
        </van-cell>
      </van-cell-group>
    </van-form>

  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Form, Field, Button, Popup, Sticky, NavBar, Area, Toast, Calendar, Radio, RadioGroup, Switch } from 'vant';
import { requestGetUserFunctionList, requestSaveUserFunctionList, requestGetBankBindList, requestSaveBankBindInfo } from '../../api/api'
// import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Sticky.name]: Sticky,
    [NavBar.name]: NavBar,
    [Area.name]: Area,
    [Calendar.name]: Calendar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Switch.name]: Switch
  },
  data() {
    return {
      lsFunctionList: [],
      lsBindList: [],
      isconsumemsg: false,
      issavemsg: false,
      ischeckcardmsg: false,
      isattendmsg: false,
      userinfo: {}
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.GetUserFunctionList()
    this.GetUserBankBindList()
    this.isconsumemsg = (this.$store.state.userinfo.msgconsume === 1)
    this.issavemsg = (this.$store.state.userinfo.msgsave === 1)
    this.ischeckcardmsg = (this.$store.state.userinfo.msgcheck === 1)
    this.isattendmsg = (this.$store.state.userinfo.msgattend === 1)
    this.userinfo = this.$store.state.userinfo

  },
  methods: {
    async SaveOptionList (functionname,item) {
      this.isLoading = true
      const res = await requestSaveUserFunctionList({accesstoken: this.$store.state.accesstoken, paramname: functionname ,paramname1: item.functionname ,paramvalue: item.isenable?1:0})
      if (res.return_code === '0') {
            Toast({
                message: res.return_message,
                icon: 'success',
            });
  
        } else {
            Toast({
                message: res.return_message,
                icon: 'fail',
            });
            item.isenable = !item.isenable
            this.isLoading = false
        }
    },
    async SaveBankBind(functionname,item) {
      if (item.isuse==='-1') {
        Toast({
            message: item.bindpayname + ' 还没有签约，请先签约再打开该功能！',
            icon: 'fail',
        });
        item.isenable = 0
        return;
      }
      this.isLoading = true
      const res = await requestSaveBankBindInfo({accesstoken: this.$store.state.accesstoken, paramname: functionname ,paramname1: item.functionname ,isuse: item.isenable?1:0,oddfare: item.oddfare, bindtype: item.bindtype})
      if (res.return_code === '0') {
            Toast({
                message: res.return_message,
                icon: 'success',
            });
        } else {
            Toast({
                message: res.return_message,
                icon: 'fail',
            });
            item.isenable = !item.isenable
            this.isLoading = false
        }
    },
    async GetUserFunctionList () {
       const res = await requestGetUserFunctionList({accesstoken: this.$store.state.accesstoken})
       if (res.return_code === '0') {
          this.lsFunctionList = res.rows
          this.lsFunctionList.forEach(i => {
            i.isenable = (i.isshow === '1')
          });
          console.log(this.lsFunctionList)
          this.isLoading = false
          if (res.rows.length === 0){
            Toast({
                message: '无数据!',
                icon: 'fail',
            });
          }
  
        } else {
            Toast({
                message: res.return_message,
                icon: 'fail',
            });
            this.isLoading = false
        }
        
    },
    async GetUserBankBindList () {
       const res = await requestGetBankBindList({accesstoken: this.$store.state.accesstoken})
       if (res.return_code === '0') {
          this.lsBindList = res.rows
          this.lsBindList.forEach(i => {
            i.isenable = (i.isuse === '1')
          });
          console.log(this.lsBindList)
          this.isLoading = false
          if (res.rows.length === 0){
            Toast({
                message: '无数据!',
                icon: 'fail',
            });
          }
  
        } else {
            Toast({
                message: res.return_message,
                icon: 'fail',
            });
            this.isLoading = false
        }
        
    } 
  }
};
</script>

<style lang="less">
  .user {
    &-poster {
      width: 100%;
      height: 53vw;
      display: block;
    }

    &-group {
      margin-bottom: 15px;
    }

    &-links {
      padding: 15px 0;
      font-size: 12px;
      text-align: center;
      background-color: #fff;

      .van-icon {
        display: block;
        font-size: 24px;
      }
    }
  }

  .m-img {
    padding-bottom: 33%;
    display: block;
    height: 80px;
    position: relative;
    max-width: 100%;
    background-size:100% 100%;
    // background-size: cover;
    background-position: center center;
    cursor: pointer;
    border-radius: 10px;
  }

  .pic {
    background-size:100% 100%;
    // width:100px;
    width: 80px;
    // height:130px;
    margin-left: 260px;
    margin-top: 70px;
    // border-radius:50%;
    //-webkit-border-radius:50%;
    //-moz-border-radius:50%;
  }
  .m-name {
    color: #000000;
    text-align: left;
    text-shadow: 0 0 2px rgba(0, 0, 0, .5);
    font-weight: 500;
    font-size: 16px;
    position: absolute;
    margin-top: -15px;
    left: 100px;
    right: 0px;
    width: 100%;
    // margin-right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }

  .m-outid {
    color: #000000;
    text-align: left;
    text-shadow: 0 0 2px rgba(0, 0, 0, .5);
    font-weight: 500;
    font-size: 16px;
    position: absolute;
    margin-top: 40px;
    left: 100px;
    right: 0px;
    width: 100%;
    // margin-right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }

  .m-dpname {
    color: #000000;
    text-align: left;
    text-shadow: 0 0 2px rgba(0, 0, 0, .5);
    font-weight: 500;
    font-size: 16px;
    position: absolute;
    margin-top: 15px;
    left: 100px;
    right: 0px;
    width: 100%;
    // margin-right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
